//@ts-nocheck
import { getConfig } from "../../config/config";
const { APP_BASE_CHARTSLAYOUT_API_URL } = getConfig();
const reqUrl = new URL(window.location);
const osParam = reqUrl.searchParams.get("osName");
export const postAutoSavePrefData = async (resolution, name, ticker, content, platform) => {
    const clientCode = localStorage.getItem("ClientCode");
    if (!clientCode) {
        console.error("ClientCode missing in localStorage");
        return null;
    }
    const url = `${APP_BASE_CHARTSLAYOUT_API_URL}api/user-preferences?user=${clientCode}&plateform=${platform}`;
    const body = {
        resolution,
        name,
        ticker,
        content,
    };
    try {
        const response = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: osParam === "Android" || osParam === "iOS" || osParam === "flutter"
                    ? "Bearer " +
                        localStorage.getItem("paramJwt").replaceAll("JwtToken=", "")
                    : "Bearer " + localStorage.getItem("JWTToken"),
            },
            body: JSON.stringify(body),
        });
        if (!response.ok) {
            console.error("POST Error:", response.status, response.statusText);
            return null;
        }
        return await response.json();
    }
    catch (err) {
        console.error("Error posting auto-save pref:", err);
        return null;
    }
};
